import { render, staticRenderFns } from "./GallerySection.vue?vue&type=template&id=ad7184da&scoped=true"
import script from "./GallerySection.vue?vue&type=script&lang=js"
export * from "./GallerySection.vue?vue&type=script&lang=js"
import style0 from "./GallerySection.vue?vue&type=style&index=0&id=ad7184da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad7184da",
  null
  
)

export default component.exports